/* istanbul ignore file */
import { MpxResponseBaseSingle, MpxResponseMeta, ProgramEngagement, getMpAgent } from '@cibo/core'
import { AxiosResponse } from 'axios'

const agent = getMpAgent()

const PATHS = {
  DOWNLOAD: '/prgDocSigning/download',
  REQUIRED: '/eqip-document/required',
  GENERATE: '/prgDocSigning/generate',
  RESEND_NOTIFICATION: '/prgDocSigning/resendNotification',
  URL: '/eqip-document/url',
  PROCESS_RETURN: '/eqip-document/processSigningReturnUrlParams',
  UPDATE_STATUS: '/prgDocSigning/updateDocStatus',
}

export type RequiredDocumentsResponse = MpxResponseMeta & { documents: { traitKey: string }[] }

export class RequiredDocumentsAPI {
  static list({ engagementId, taskId }: { engagementId: string; taskId: string }) {
    return agent
      .get<RequiredDocumentsResponse>(PATHS.REQUIRED, { params: { id: engagementId, taskId } })
      .then(response => response.data)
  }

  static generate({
    engagementId,
    taskId,
    returnUrl,
  }: {
    engagementId: string
    taskId: string
    returnUrl: string
  }) {
    return agent
      .post<MpxResponseMeta>(
        `${PATHS.GENERATE}`,
        { id: engagementId, taskId, returnUrl },
        { timeout: 180_000 } // generating pdf then signing package
      )
      .then(response => response.data)
  }

  static resendNotification({ engagementId, taskId }: { engagementId: string; taskId: string }) {
    return agent
      .post<MpxResponseMeta>(PATHS.RESEND_NOTIFICATION, { id: engagementId, taskId })
      .then(response => response.data)
  }

  static updateStatus({ engagementId, taskId }: { engagementId: string; taskId: string }) {
    return agent.post<MpxResponseBaseSingle<ProgramEngagement>>(PATHS.UPDATE_STATUS, {
      id: engagementId,
      taskId,
    })
  }

  static url({
    engagementId,
    taskId,
    returnUrl,
  }: {
    engagementId: string
    taskId: string
    returnUrl: string
  }) {
    return agent
      .get<MpxResponseMeta & { docusignUrl: string }>(PATHS.URL, {
        params: {
          id: engagementId,
          returnUrl,
          taskId,
        },
      })
      .then(response => response.data)
  }

  static download({ engagementId, taskId }: { engagementId: string; taskId: string }) {
    return agent.get<AxiosResponse>(PATHS.DOWNLOAD, {
      params: {
        id: engagementId,
        taskId,
      },
      responseType: 'blob',
    })
  }

  static processSigningReturn({
    engagementId,
    taskId,
    eventParam,
  }: {
    engagementId: string
    taskId: string
    eventParam: string
  }) {
    return agent.post<MpxResponseBaseSingle<ProgramEngagement>>(PATHS.PROCESS_RETURN, {
      id: engagementId,
      event: eventParam,
      taskId,
    })
  }
}
